var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleplay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 52,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M173.095 52H6.657C2.997 52 0 49.073 0 45.5v-39C0 2.927 2.998 0 6.657 0h166.438c3.66 0 6.658 2.927 6.658 6.5v39c0 3.573-2.998 6.5-6.658 6.5z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M173.095 1.042c3.082 0 5.591 2.449 5.591 5.458v39c0 3.01-2.509 5.458-5.591 5.458H6.657c-3.082 0-5.59-2.448-5.59-5.458v-39c0-3.01 2.508-5.458 5.59-5.458h166.438zm0-1.042H6.657C2.997 0 0 2.927 0 6.5v39C0 49.073 2.998 52 6.657 52h166.438c3.66 0 6.658-2.927 6.658-6.5v-39c0-3.573-2.998-6.5-6.658-6.5z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.136 13.317c0 1.085-.333 1.955-.988 2.603-.754.769-1.736 1.156-2.94 1.156-1.15 0-2.132-.394-2.937-1.169-.807-.786-1.21-1.752-1.21-2.907s.403-2.12 1.21-2.9c.805-.782 1.787-1.175 2.937-1.175.573 0 1.119.115 1.64.33.52.215.942.508 1.248.869l-.696.685c-.534-.615-1.261-.92-2.192-.92a3.09 3.09 0 00-2.183.864c-.611.578-.917 1.327-.917 2.247 0 .92.306 1.675.917 2.254.617.57 1.345.863 2.183.863.89 0 1.64-.293 2.23-.87.39-.381.611-.908.67-1.58h-2.9v-.94h3.868c.047.203.06.4.06.59zM69.273 10.06H65.64v2.47h3.275v.94H65.64v2.47h3.633v.957h-4.662V9.103h4.662v.957zM73.604 16.897h-1.029V10.06h-2.229v-.957h5.488v.957h-2.23v6.837zM79.805 16.897V9.103h1.027v7.794h-1.027zM85.384 16.897h-1.02V10.06h-2.237v-.957h5.494v.957h-2.237v6.837zM98.01 15.894c-.787.788-1.762 1.182-2.926 1.182-1.17 0-2.145-.394-2.932-1.182-.786-.786-1.177-1.752-1.177-2.894 0-1.142.391-2.108 1.177-2.894.787-.788 1.762-1.181 2.932-1.181 1.157 0 2.132.393 2.92 1.187.792.793 1.183 1.752 1.183 2.888 0 1.142-.391 2.108-1.177 2.894zm-5.098-.653c.593.583 1.313.876 2.172.876.852 0 1.58-.293 2.166-.876.59-.583.89-1.333.89-2.241 0-.908-.3-1.658-.89-2.24-.586-.584-1.314-.877-2.166-.877-.859 0-1.58.293-2.172.876-.59.583-.89 1.333-.89 2.241 0 .908.3 1.658.89 2.24zM100.63 16.897V9.103h1.248l3.881 6.062h.045l-.045-1.499V9.103h1.027v7.794h-1.071l-4.065-6.36h-.045l.045 1.504v4.856h-1.02z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.722 28.278c-3.128 0-5.682 2.324-5.682 5.53 0 3.18 2.554 5.528 5.682 5.528 3.134 0 5.689-2.348 5.689-5.528 0-3.206-2.555-5.53-5.69-5.53zm0 8.88c-1.716 0-3.192-1.382-3.192-3.35 0-1.994 1.476-3.352 3.192-3.352 1.716 0 3.199 1.358 3.199 3.352 0 1.968-1.483 3.35-3.2 3.35zm-12.398-8.88c-3.134 0-5.682 2.324-5.682 5.53 0 3.18 2.548 5.528 5.682 5.528 3.132 0 5.682-2.348 5.682-5.528 0-3.206-2.55-5.53-5.682-5.53zm0 8.88c-1.718 0-3.2-1.382-3.2-3.35 0-1.994 1.482-3.352 3.2-3.352 1.716 0 3.192 1.358 3.192 3.352 0 1.968-1.476 3.35-3.192 3.35zM63.57 29.974v2.35h5.747c-.168 1.313-.618 2.278-1.307 2.95-.838.813-2.145 1.715-4.44 1.715-3.537 0-6.306-2.787-6.306-6.24 0-3.453 2.769-6.24 6.306-6.24 1.912 0 3.304.73 4.33 1.676l1.697-1.656c-1.437-1.34-3.347-2.368-6.027-2.368-4.85 0-8.926 3.853-8.926 8.588 0 4.735 4.076 8.588 8.926 8.588 2.621 0 4.59-.838 6.138-2.411 1.586-1.549 2.08-3.726 2.08-5.484a7.68 7.68 0 00-.13-1.468h-8.088zm60.327 1.822c-.468-1.237-1.911-3.517-4.85-3.517-2.913 0-5.338 2.241-5.338 5.53 0 3.097 2.4 5.528 5.617 5.528a5.647 5.647 0 004.721-2.45l-1.931-1.256c-.644.92-1.521 1.529-2.79 1.529-1.26 0-2.163-.564-2.743-1.675l7.575-3.06-.261-.63zm-7.723 1.84a3.067 3.067 0 012.958-3.223c.988 0 1.827.483 2.107 1.173l-5.065 2.05zM110.019 39h2.489V22.75h-2.489V39zm-4.078-9.49h-.083c-.56-.647-1.626-1.232-2.978-1.232-2.836 0-5.43 2.431-5.43 5.548 0 3.099 2.594 5.51 5.43 5.51 1.352 0 2.418-.59 2.978-1.256h.083v.793c0 2.114-1.157 3.25-3.023 3.25-1.521 0-2.465-1.072-2.854-1.974l-2.165.882c.624 1.466 2.276 3.27 5.019 3.27 2.92 0 5.383-1.677 5.383-5.758v-9.928h-2.36v.895zm-2.848 7.649c-1.716 0-3.152-1.402-3.152-3.333 0-1.948 1.436-3.37 3.152-3.37 1.691 0 3.024 1.422 3.024 3.37 0 1.93-1.333 3.333-3.024 3.333zm32.462-14.409H129.6V39h2.483v-6.157h3.472c2.758 0 5.463-1.949 5.463-5.047s-2.712-5.046-5.463-5.046zm.065 7.832h-3.537V25.01h3.537a2.854 2.854 0 012.913 2.786c0 1.257-1.059 2.787-2.913 2.787zm15.35-2.335c-1.794 0-3.659.774-4.427 2.488l2.204.902c.474-.902 1.346-1.194 2.268-1.194 1.289 0 2.595.755 2.615 2.09v.17c-.449-.253-1.411-.629-2.595-.629-2.373 0-4.791 1.276-4.791 3.657 0 2.177 1.944 3.58 4.129 3.58 1.671 0 2.593-.737 3.172-1.593h.085v1.256h2.399v-6.233c0-2.882-2.204-4.494-5.059-4.494zm-.299 8.905c-.812 0-1.944-.393-1.944-1.376 0-1.258 1.411-1.74 2.633-1.74 1.093 0 1.606.235 2.27.546-.195 1.504-1.521 2.57-2.959 2.57zm14.095-8.549l-2.854 7.045h-.085l-2.951-7.045h-2.678l4.434 9.844-2.53 5.478h2.595l6.832-15.322h-2.763zM142.382 39h2.49V22.75h-2.49V39z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.894 9.8c-.391.4-.617 1.022-.617 1.829v28.749c0 .806.226 1.428.617 1.828l.097.088 16.5-16.104v-.38l-16.5-16.104-.097.094z",
    fill: "url(#googleplay_svg__paint0_linear_73_1803)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.986 31.56l-5.494-5.37v-.38l5.5-5.37.123.07 6.515 3.618c1.859 1.027 1.859 2.717 0 3.75l-6.515 3.613-.13.07z",
    fill: "url(#googleplay_svg__paint1_linear_73_1803)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.115 31.49L30.491 26 13.894 42.206c.618.634 1.625.71 2.77.076l19.451-10.791z",
    fill: "url(#googleplay_svg__paint2_linear_73_1803)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.115 20.51L16.664 9.717c-1.145-.628-2.152-.551-2.77.082L30.491 26l5.624-5.49z",
    fill: "url(#googleplay_svg__paint3_linear_73_1803)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "googleplay_svg__paint0_linear_73_1803",
    x1: 29.026,
    y1: 40.677,
    x2: 7.215,
    y2: 18.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "googleplay_svg__paint1_linear_73_1803",
    x1: 45.051,
    y1: 25.998,
    x2: 12.832,
    y2: 25.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "googleplay_svg__paint2_linear_73_1803",
    x1: 33.057,
    y1: 23.015,
    x2: 3.48,
    y2: -7.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "googleplay_svg__paint3_linear_73_1803",
    x1: 9.716,
    y1: 51.771,
    x2: 22.924,
    y2: 38.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
export default SvgGoogleplay;